// src/stages/stage1Plant/Trees.jsx
import React, { useMemo } from "react";
import { useGLTF } from "@react-three/drei";

const TREE_DEAD = "/stageAssets/stage1-plant/TreeOnly.glb";
const PINE_TREE = "/stageAssets/stage1-plant/PineTree.glb";

function TreeInstance({
  scene,
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
}) {
  const clonedScene = useMemo(() => {
  const clone = scene.clone(true);

  clone.traverse((obj) => {
    if (obj.isMesh) {
      obj.castShadow = true;
      obj.receiveShadow = true;
    }
  });

  return clone;
}, [scene]);

  return (
    <primitive
      object={clonedScene}
      position={position}
      rotation={rotation}
      scale={scale}
    />
  );
}

export default function Trees() {
  const { scene: treeScene } = useGLTF(TREE_DEAD);
  const { scene: pineTreeScene } = useGLTF(PINE_TREE);

 const treeData = [
  {
    id: "tree-01",
    type: "tree",
    position: [0.5, 0, 2.5],
    rotation: [0, -1.2, 0],
    scale: 4,
  },
  // {
  //   id: "tree-02",
  //   type: "tree",
  //   position: [-1.85, 0, -3.5],
  //   rotation: [0, 0.5, 0],
  //   scale: 3,
  // },
  {
    id: "pine-00",
    type: "pine",
    position: [-4, -0.3, 0],
    rotation: [0, 0.5, 0],
    scale: 1,
  },
  {
    id: "pine-01",
    type: "pine",
    position: [1.9, -0.2, 1.5],
    rotation: [0, 0, 0],
    scale: 1,
  },
  // {
  //   id: "pine-02",
  //   type: "pine",
  //   position: [-1, -0.2, -5.5],
  //   rotation: [0, 0, 0],
  //   scale: 1,
  // },
  {
    id: "pine-03",
    type: "pine",
    position: [-2.5, -0.2, 2.25],
    rotation: [0, -0.15, 0],
    scale: 1,
  },
  {
    id: "pine-04",
    type: "pine",
    position: [0.3, -0.2, -3],
    rotation: [0, 0.5, 0],
    scale: 1,
  },
];

  return (
    <group name="trees">
      {treeData.map((tree) => {
        let scene;

        if (tree.type === "tree") {
          scene = treeScene;
        } else if (tree.type === "pine") {
          scene = pineTreeScene;
        } else {
          scene = stumpScene;
        }

        return (
          <TreeInstance
            key={tree.id}
            scene={scene}
            position={tree.position}
            rotation={tree.rotation}
            scale={tree.scale}
          />
        );
      })}
    </group>
  );
}

useGLTF.preload(TREE_DEAD);
useGLTF.preload(PINE_TREE);